import { IsBoolean } from "class-validator";

export class ResetPasswordResult {
    @IsBoolean()
    success: boolean;
}